import React, { FC, useEffect, useState } from "react";
import { Button, Form } from "antd";
import dayjs from "dayjs";
import DocumentUpload from "../../PreAuth/PreAuthEchs/DocumentUpload";
import ResponseDocumentUpload from "../../PreAuth/PreAuthEchs/ResponseDocumentUpload";
import { Spin } from "antd";
import { useUserFunctionalities } from "../../../../utils/UserFunctionalities";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { ROUTES } from "../../../../utils/constants";
import { useNavigate } from "react-router-dom";
import IncentiveDetails from "./IncentiveDetails";
import HospitalBillDetails from "./HospitalBillDetails";
import Others from "./Others";

interface ClaimAyushmanProps {
  claimData: any;
  isEditable: boolean;
  caseClaimSubmissionId: number | null;
  portalSubmission: boolean;
  handleDeleteProcedure?: (procedure: any) => boolean;
  form: any;
  loading: boolean;
  documentTypes: any[];
  documentUrls: any[];
  documentRequestResponseDocuments: any;
  handleFileChange: any;
  handleOpen: any;
  isApproved: boolean;
  handleSaveData: any;
  preAuth: any;
  activeKey: any;
  isIntimating: boolean;
  caseClaimId: any;
  isSubmitting: boolean;
  isSaving: boolean;
  handleSaveConfirmationModal: any;
  isApprovedInitiated: boolean;
  uploadFileList: any;
  handleModalOpen: any;
  uploadedOtherFileList: any[];
  uploadedFileColumns: any[];
}

interface TotalAmountDetailsProps {
  totalPackageAmount?: string;
  adjustedPackageAmount?: string;
  totalPayableAmount?: string;
  eRupiAmount?: string;
  miscAmount?: string;
}

const ClaimAyushman: FC<ClaimAyushmanProps> = ({
  claimData,
  portalSubmission,
  form,
  loading,
  documentTypes,
  documentUrls,
  documentRequestResponseDocuments,
  handleFileChange,
  handleOpen,
  isApproved,
  handleSaveData,
  preAuth,
  activeKey,
  isIntimating,
  caseClaimId,
  isSubmitting,
  isSaving,
  handleSaveConfirmationModal,
  isApprovedInitiated,
  uploadFileList,
  handleModalOpen,
  uploadedOtherFileList,
  uploadedFileColumns,
}) => {
  const { hasFunctionality } = useUserFunctionalities();
  const { auth, patients } = useSelector((state: RootState) => state);
  const navigate = useNavigate();
  const [packageFinanceData, setPackageFinanceData] = useState([]);
  const [totalAmountData, setTotalAmountData] =
    useState<TotalAmountDetailsProps | null>(null);

  useEffect(() => {
    if (claimData) {
      // Set initial form values if there's existing data
      form.setFieldsValue({
        ...claimData?.hospitalBill,
        billDate: claimData?.hospitalBill?.billDate
          ? dayjs(claimData?.hospitalBill?.billDate, "DD-MM-YYYY HH:mm:ss")
          : null,
      });
    }
  }, [claimData, form]);

  useEffect(() => {
    if (claimData?.financeDetails) {
      const financeAmountDetails =
        claimData?.financeDetails?.finance?.amountDetails;
      setPackageFinanceData(financeAmountDetails || []);

      const totalAmounts = {
        totalPackageAmount:
          financeAmountDetails?.totalPackageAmountWithoutIncentives,
        adjustedPackageAmount:
          financeAmountDetails?.totalAdjustedPackageAmountAsPerGuidelines,
        totalPayableAmount: financeAmountDetails?.totalPayableAmount,
        eRupiAmount: financeAmountDetails?.eRupiAmount,
        miscAmount: financeAmountDetails?.miscAmount,
      };
      setTotalAmountData(totalAmounts || null);
    }
  }, [claimData?.financeDetails]);

  return (
    <>
      <Form form={form} layout="vertical">
        {/* <PatientDetails form={form} />
        <ReferralDetailsEchs form={form} /> */}

        <IncentiveDetails
          packageFinanceData={packageFinanceData}
          totalAmountData={totalAmountData}
        />
        <HospitalBillDetails claimData={claimData} />
        <Others
          handleModalOpen={handleModalOpen}
          uploadedOtherFileList={uploadedOtherFileList}
          uploadedFileColumns={uploadedFileColumns}
          claimData={claimData}
        />
        {loading ? (
          <div
            style={{
              margin: "auto",
              width: "100%,",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          documentRequestResponseDocuments?.["requestedDocuments"]?.length >
            0 && (
            <DocumentUpload
              documentTypes={documentTypes}
              documentUrls={documentUrls}
              handleFileChange={handleFileChange}
              handleOpen={handleOpen}
              documentRequestResponseDocuments={
                documentRequestResponseDocuments
              }
              portalSubmission={portalSubmission}
              isApproved={isApproved}
              uploadFileList={uploadFileList}
              isIntimated={claimData?.intimated}
            />
          )
        )}

        {documentRequestResponseDocuments?.["responseDocuments"]?.length >
          0 && (
          <ResponseDocumentUpload
            documentTypes={documentTypes}
            documentUrls={documentUrls}
            handleFileChange={handleFileChange}
            handleOpen={handleOpen}
            portalSubmission={portalSubmission}
            documentRequestResponseDocuments={documentRequestResponseDocuments}
            handleSaveData={handleSaveData}
            currentStage={preAuth?.stepperData?.currentVisitStage}
            activeKey={activeKey}
            uploadFileList={uploadFileList}
          />
        )}
      </Form>
      <div className="buttons" style={{ margin: "16px 0" }}>
        {
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.8rem",
            }}
          >
            {claimData?.submitted || claimData?.initiated ? (
              // || claimData?.approved
              <></>
            ) : !caseClaimId ? (
              hasFunctionality("claimCreation") && (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleSubmit}
                    onClick={() => handleSaveConfirmationModal("save")}
                    loading={isSaving}
                  >
                    SAVE
                  </Button>
                </div>
              )
            ) : (
              hasFunctionality("claimCreation") && (
                // !(auth?.role?.role == "FO_STAFF" && claimData?.intimated) &&
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleSubmit}
                    onClick={() => handleSaveConfirmationModal("update")}
                    loading={isSaving}
                  >
                    Update
                  </Button>
                </div>
              )
            )}

            {hasFunctionality("claimIntimation") ? (
              claimData?.intimated ||
              claimData?.submitted ||
              claimData?.initiated ||
              claimData?.approved ? (
                <></>
              ) : (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleIntimate}
                    onClick={() => handleSaveConfirmationModal("intimate")}
                    loading={isIntimating}
                  >
                    Send To QC
                  </Button>
                </div>
              )
            ) : (
              <></>
            )}

            {/* {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
              "OP" &&
              (hasFunctionality("opdBillList") ||
                hasFunctionality("ipdBillList")) && (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                      opacity: !isApproved ? 1 : 0.5,
                      pointerEvents: !isApproved ? "auto" : "none",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
                        navigate({
                          pathname: `${ROUTES.PATIENT_BILLING_LIST}/${patients?.fetchBasicDetails?.casesResponse?.id}/${patients?.fetchBasicDetails?.visitInfoResponse?.id}`,
                        });
                      }
                    }}
                  >
                    Bill Audit
                  </Button>
                </div>
              )} */}

            {hasFunctionality("claimApprover") &&
              !claimData?.initiated &&
              !claimData?.approved &&
              !claimData?.submitted && (
                <div style={{ width: "16%" }}>
                  <Button
                    loading={isApprovedInitiated}
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                      opacity: !isApproved ? 1 : 0.5,
                      pointerEvents: !isApproved ? "auto" : "none",
                    }}
                    // onClick={handleApprove}
                    onClick={() => handleSaveConfirmationModal("approve")}
                    disabled={isApproved}
                  >
                    Qc Approve
                  </Button>
                </div>
              )}

            {claimData?.submitted || claimData?.initiated ? (
              <></>
            ) : (
              hasFunctionality("claimSubmission") && (
                <div style={{ width: "16%" }}>
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "rgb(0, 76, 143)",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      width: "100%",
                    }}
                    // onClick={handleSubmitOnPortal}
                    onClick={() => handleSaveConfirmationModal("submit")}
                    loading={isSubmitting}
                  >
                    {patients?.fetchBasicDetails?.casesResponse
                      ?.integratedWithPortal
                      ? "Initiate"
                      : "Submit Manually"}
                  </Button>
                </div>
              )
            )}
          </div>
        }
      </div>
    </>
  );
};

export default React.memo(ClaimAyushman);
